/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import mcCannLogoWhite from 'assets/img/fpmccann white.png';
import mcCannLogo from 'assets/img/logoMcCann.png';

export default function header(props) {
    const { isLandingPage } = props;

    //if (EasiPoprtalUser ==) {
    //    use orgial return and header
    //}
    //else {
    //    create a new and chnage the links and style for the qurray user
    //    import Header from "components/Header/Header.js";
    //    import HeaderLinks from "components/Header/HeaderLinks.js";
    //}


    return (
        <div>
            <Header
                brand={
                    <div style={{ textAlign: "center", display: "flex", gap: "1rem" }}>
                        {isLandingPage ? (
                            <img
                                src={mcCannLogo}
                                height={50}
                                width={65}
                                alt="FPMcCannLogo"
                            />
                        ) : (
                        <img
                            src={mcCannLogoWhite}
                            height={50}
                            width={75}
                            alt="FPMcCannLogo"
                        />
                        )}
                        {' '}
                    </div>}

                links={<HeaderLinks dropdownHoverColor="info" isLandingPage={isLandingPage} />}
                fixed
                color={isLandingPage ? "transparent" : "info"}
                changeColorOnScroll={{
                    height: 50,
                    color: "info",

                }}>


            </Header>
        </div>
    );
}
